import script from "./DecorationUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./DecorationUpload.vue?vue&type=script&setup=true&lang=ts"

import "./DecorationUpload.vue?vue&type=style&index=0&id=5062c0d2&lang=css"

const __exports__ = script;

export default __exports__